import { OperationDefinitionNode } from 'graphql';
import { Operation } from '@apollo/client';
export class OperationMetadata {
  private operation: Operation;
  constructor(operation: Operation) {
    this.operation = operation || {};
  }
  getType(): string {
    const operationDefination =
      (this.operation.query?.definitions[0] as OperationDefinitionNode) || {};
    return operationDefination?.operation || 'unknownType';
  }
  getName(): string {
    return this.operation.operationName || 'unknownName';
  }
  getFullName(): string {
    return `${this.getType()}.${this.getName()}`;
  }
}
